import { combineReducers } from 'redux';
import UserReducer from './User';

const rootReducer = combineReducers({
  UserReducer,
});
export default rootReducer;
